import { makeCallApiPromise } from '@listening/utils/call-api-promise';
import { createIsomorphicFn } from '@tanstack/react-start';
import { notFound } from '@tanstack/react-router';
import { serverRuntime } from './server-runtime.server';
import { clientRuntime } from './client-runtime';
import { ApiClient } from '@listening/api-contract/api-client-tag';

export const getRuntime = createIsomorphicFn()
  .server(() => serverRuntime)
  .client(() => clientRuntime);

export const callApiPromise = makeCallApiPromise(ApiClient, getRuntime, {
  throwOnTag: {
    NotFoundError: () => notFound(),
  },
});
